import { getUniqueString as n } from "../../common/utils/index.js";
import { createElementBlock as a, openBlock as i, normalizeClass as d, createCommentVNode as l, renderSlot as r, createTextVNode as o, toDisplayString as s } from "vue";
import { _ as g } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  compatConfig: { MODE: 3 },
  name: "DtListItemGroup",
  props: {
    /**
     * Id of the List Item Group
     */
    id: {
      type: String,
      default() {
        return n();
      }
    },
    /**
     * List's heading.
     */
    heading: {
      type: String,
      default: ""
    },
    /**
     * Additional class to style the heading
     */
    headingClass: {
      type: [String, Array, Object],
      default: ""
    },
    /**
     * Additional class for the wrapper list element.
     */
    listClass: {
      type: [String, Array, Object],
      default: ""
    }
  }
}, u = ["id", "aria-labelledby"], m = ["id"];
function f(t, p, e, h, _, y) {
  return i(), a("ul", {
    id: e.id,
    class: d(["d-list-item-group", e.listClass]),
    role: "group",
    "data-qa": "dt-dropdown-list-wrapper",
    "aria-labelledby": `${e.id}-heading`
  }, [
    e.heading ? (i(), a("li", {
      key: 0,
      id: `${e.id}-heading`,
      role: "presentation",
      "data-qa": "dt-dropdown-list-heading",
      class: d(["dt-dropdown-list--header", e.headingClass])
    }, [
      r(t.$slots, "headingSlot", {}, () => [
        o(s(e.heading), 1)
      ])
    ], 10, m)) : l("", !0),
    r(t.$slots, "default")
  ], 10, u);
}
const w = /* @__PURE__ */ g(c, [["render", f]]);
export {
  w as default
};
//# sourceMappingURL=list-item-group.js.map
